import React from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import styles from './../style/Keysi.module.scss'
import { Container, Image, Modal } from 'react-bootstrap'
import WhiteBlockTitle from './WhiteBlockTitle'
import GreenButton from './GreenButton'
import FeedbackForm from './FeedbackForm'
import ClientOnlyFsLightbox from './ClientOnlyFsLightbox'

class Keysi extends React.Component {
  constructor(props) {
    super(props)
    this.swiperRef = React.createRef()
    this.modalSwiperRef = React.createRef()
    this.nextSlide = this.nextSlide.bind(this)
    this.prevSlide = this.prevSlide.bind(this)
    this.nextModalSlide = this.nextModalSlide.bind(this)
    this.prevModalSlide = this.prevModalSlide.bind(this)
    this.state = {
      activeIndex: 0,
      modalActiveIndex: 0,
      showModal: false,
      currentSlideData: null,
      show_feedback: false,
      showVideoModal: false,
      lightboxController: {
        toggler: false,
        slide: 1
      }
    }
  }

  nextSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slideNext()
    }
  }

  prevSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slidePrev()
    }
  }

  nextModalSlide() {
    if (this.modalSwiperRef.current && this.modalSwiperRef.current.swiper) {
      this.modalSwiperRef.current.swiper.slideNext()
    }
  }

  prevModalSlide() {
    if (this.modalSwiperRef.current && this.modalSwiperRef.current.swiper) {
      this.modalSwiperRef.current.swiper.slidePrev()
    }
  }

  handleSlideChange = () => {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.setState({
        activeIndex: this.swiperRef.current.swiper.realIndex
      })
    }
  }

  handleModalSlideChange = () => {
    if (this.modalSwiperRef.current && this.modalSwiperRef.current.swiper) {
      this.setState({
        modalActiveIndex: this.modalSwiperRef.current.swiper.realIndex
      })
    }
  }

  openModal = (slideData) => {
    this.setState({
      showModal: true,
      currentSlideData: slideData,
      modalActiveIndex: 0
    })
  }

  closeModal = () => {
    this.setState({
      showModal: false,
      currentSlideData: null,
      showVideoModal: false
    })
  }

  openVideoModal = () => {
    this.setState({ showVideoModal: true })
  }

  closeVideoModal = () => {
    this.setState({ showVideoModal: false })
  }

  // Функция для открытия лайтбокса
  openLightbox = (index) => {
    this.setState({
      lightboxController: {
        toggler: !this.state.lightboxController.toggler,
        slide: index + 1
      }
    })
  }

  formatSlideNumber = (index) => {
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  showFeedback = () => {
    this.closeModal()
    this.setState({ show_feedback: true })
  }
  
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  // Функция для определения типа видео и получения embed URL
  getVideoEmbedUrl = (videoUrl) => {
    if (!videoUrl) return '';
    
    // YouTube
    if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
      let videoId = '';
      if (videoUrl.includes('youtu.be')) {
        videoId = videoUrl.split('/').pop();
      } else {
        const urlParams = new URLSearchParams(new URL(videoUrl).search);
        videoId = urlParams.get('v');
      }
      return `https://www.youtube.com/embed/${videoId}`;
    }
    
    // Rutube
    if (videoUrl.includes('rutube.ru')) {
      // Для Rutube нужно извлечь video ID из URL
      const match = videoUrl.match(/rutube\.ru\/(?:video\/|shorts\/)?([a-zA-Z0-9]+)/);
      if (match && match[1]) {
        return `https://rutube.ru/play/embed/${match[1]}`;
      }
    }
    
    // VK
    if (videoUrl.includes('vk.com') || videoUrl.includes('vk.ru')) {
      // VK обычно требует специальной обработки, возвращаем оригинальный URL
      return videoUrl;
    }
    
    return videoUrl;
  }

  render() {
    const { data } = this.props
    const { showModal, currentSlideData, show_feedback, showVideoModal, lightboxController } = this.state

    return (
      <section className={`${styles.section}`}>
        <Container>
          <WhiteBlockTitle
            title={data?.title || ``}
            text={data?.text || ``}
            className={styles.title}
          />

          <div className={styles.swiper_container}>
            <Swiper
              ref={this.swiperRef}
              modules={[Navigation]}
              spaceBetween={10}
              slidesPerView={2}
              loop={true}
              onSlideChange={this.handleSlideChange}
              onSwiper={(swiper) => {
                this.setState({ activeIndex: swiper.realIndex })
              }}
              breakpoints={{
                768: {
                  slidesPerView: 1
                },
                1202: {
                  slidesPerView: 2
                }
              }}
            >
              {data?.list.map((slide, index) => (
                <SwiperSlide key={index}>
                  <div className={styles.slyde}>
                    <div>
                      <div className={styles.title}>
                        <div>{slide?.name}</div>
                        <div className={styles.title_num}>{this.formatSlideNumber(index)}</div>
                      </div>
                      <div className={styles.podpis}>{slide?.podpis}</div>
                      <div className={styles.anons} dangerouslySetInnerHTML={{__html: slide?.anons}} />
                      <GreenButton
                        text={`Подробнее`}
                        width={247}
                        className={styles.btn}
                        action={() => this.openModal(slide)}
                      />
                    </div>
                    <Image onClick={() => this.openModal(slide)} className={styles.image} src={slide?.image} alt={slide?.name} width='272' height='190' />
                    <GreenButton
                      text={`Подробнее`}
                      width={247}
                      className={styles.btn_mob}
                      action={() => this.openModal(slide)}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className={styles.slydenav_btns}>
              <div></div>
              <div className={styles.slydenav_btn} onClick={this.nextSlide}>
                <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.678817 4.50087H10.3212M10.3212 4.50087L6.46424 0.643924M10.3212 4.50087L6.46424 8.35782" stroke="white" strokeLinecap="round" />
                </svg>
              </div>
            </div>
          </div>
        </Container>

        {/* Lightbox компонент */}
        <ClientOnlyFsLightbox
          toggler={lightboxController.toggler}
          sources={currentSlideData?.slyder?.map(item => item.full || item.image)}
          slide={lightboxController.slide}
        />

        {/* Модальное окно */}
        <Modal 
          show={showModal} 
          onHide={this.closeModal}
          centered
          dialogClassName={styles.modal_dialog}
          contentClassName={styles.modal_content}
        >
          <Modal.Body className={styles.modal_body}>
            <button 
              className={styles.modal_close} 
              onClick={this.closeModal}
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L13 13M13 1L1 13" stroke="black" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
            
            {currentSlideData && (
              <>
                <div className={styles.modal_header}>
                  <div className={styles.modal_title}>{currentSlideData.name}</div>
                </div>
                
                <div className={styles.modal_podpis}>{currentSlideData.podpis}</div>
                
                {/* Слайдер фотографий в модальном окне */}
                <div className={styles.modal_slider_container}>
                  <Swiper
                    ref={this.modalSwiperRef}
                    modules={[Navigation]}
                    spaceBetween={0}
                    slidesPerView={1}
                    loop={true}
                    onSlideChange={this.handleModalSlideChange}
                    onSwiper={(swiper) => {
                      this.setState({ modalActiveIndex: swiper.realIndex })
                    }}
                  >
                    {currentSlideData.slyder.map((image, index) => (
                      <SwiperSlide key={index}>
                        <div 
                          className={styles.modal_image_container}
                          onClick={() => this.openLightbox(index)}
                          style={{cursor: 'pointer'}}
                        >
                          <Image 
                            src={image.image} 
                            alt={image.name}
                            className={styles.modal_image}
                          />
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  
                  {/* Стрелки навигации для модального слайдера */}
                  {currentSlideData.slyder.length > 1 && (
                    <div className={styles.modal_nav_btns}>
                      <div className={styles.modal_nav_btn} onClick={this.prevModalSlide}>
                        <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.3212 4.50087H1.67882M1.67882 4.50087L5.53576 0.643924M1.67882 4.50087L5.53576 8.35782" stroke="white" strokeLinecap="round" />
                        </svg>
                      </div>
                      <div className={styles.modal_nav_btn} onClick={this.nextModalSlide}>
                        <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.678817 4.50087H10.3212M10.3212 4.50087L6.46424 0.643924M10.3212 4.50087L6.46424 8.35782" stroke="white" strokeLinecap="round" />
                        </svg>
                      </div>
                    </div>
                  )}
                </div>

                {/* Блок с видео */}
                {currentSlideData.video && (
                  <div className={styles.video_block}>
                    <div 
                      className={styles.video_poster_container}
                      onClick={this.openVideoModal}
                    >
                      <Image 
                        src={currentSlideData.poster} 
                        alt="Video poster"
                        className={styles.video_poster}
                      />
                      <div className={styles.play_button}>
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <ellipse cx="17.9819" cy="17.9439" rx="17.9819" ry="17.9439" fill="white"/>
                          <path d="M23.5986 15.9972C25.0983 16.8612 25.0983 19.0254 23.5986 19.8895L15.82 24.371C14.3227 25.2336 12.4528 24.1529 12.4528 22.4248L12.4528 13.4619C12.4528 11.7338 14.3227 10.653 15.82 11.5157L23.5986 15.9972Z" fill="#00C775"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                )}
                
                <div className={styles.modal_text} dangerouslySetInnerHTML={{__html: currentSlideData.text}} />

                <GreenButton
                  text={`Нужна консультация`}
                  width={247}
                  className={styles.btn_mob}
                  action={() => this.showFeedback()}
                />
              </>
            )}
          </Modal.Body>
        </Modal>

        {/* Модальное окно для видео */}
        <Modal 
          show={showVideoModal} 
          onHide={this.closeVideoModal}
          centered
          size="lg"
          dialogClassName={styles.video_modal_dialog}
          contentClassName={styles.video_modal_content}
        >
          <Modal.Body className={styles.video_modal_body}>
            <button 
              className={styles.video_modal_close} 
              onClick={this.closeVideoModal}
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L13 13M13 1L1 13" stroke="white" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
            
            {currentSlideData?.video && (
              <div className={styles.video_container}>
                <iframe
                  width="100%"
                  height="405"
                  src={this.getVideoEmbedUrl(currentSlideData.video)}
                  title="Video player"
                  className={styles.video_iframe}
                  allowFullScreen
                  autoPlay
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                />
              </div>
            )}
          </Modal.Body>
        </Modal>

        <FeedbackForm
          title={`Нужна консультация`}
          text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
          btn={`Отправить`}
          data={[]}
          show={show_feedback}
          handleClose={() => this.closeFeedback()}
        />
      </section>
    )
  }
}

Keysi.propTypes = {
  data: PropTypes.object
}

Keysi.defaultProps = {
  data: {}
}

export default Keysi